import React from 'react';
import ContentLayout from '../../components/ContentLayout';
import props from '../../lib/contentLayoutProps/the-kingston-difference/layoutProps';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="zh" pageKey="">
    <h1>京斯敦與眾不同之處</h1>
    <p>
      我們對於學生運用雙語的能力感到無比的驕傲。京斯敦為提供優質的環境讓學生學習純正的普通話及英文。這裡小班教學、師生比例極佳的條件為我們雙語的學習環境打好根基，並形成國際文憑小學課程的框架。
    </p>
    <p>
      京斯敦國際學校為一歲至十一歲的學生提供國際文憑小學雙語課程(英文／普通話)。京斯敦共有三所校舍：幼兒園及幼稚園部為一至四歲學生提供幼兒教育課程、低年級校舍供一年級至三年級學生就讀，而高年級校舍則供四年級至六年級學生就讀。雖然分成三所校舍，但我們依然是一所溫馨舒適的小型學校。我們推行小班教學，每班分別有兩位母語為普通話及英文的班主任。
    </p>
  </ContentLayout>
);
